// Experimental-features preference — the product-wide gate for every «Próx»
// (in-development) feature. If something is marked «Próx», gate it on THIS flag
// (via the `useExpFeatures()` hook — the canonical React entry point — never on
// a hardcoded const): nav sections, bulk / multi-select, «en lote» / CSV
// buttons, any in-dev surface. See useExpFeatures.js for the consumption
// contract and the live list of consumers.
//
// Off by default, as in the prototype: a "Próx" affordance such as bulk
// select or the «en lote» and CSV buttons renders disabled until the user
// opts in from Preferences. Opting in enables the affordance and keeps its
// «Próx» badge. Built on the shared createPreference primitive, with the
// boolean stored as '1' or '0'. The CustomEvent lets subscribers in other
// trees, such as the Sidebar and the lists, re-render when the toggle flips.
import { createPreference } from './preference';

export const expFeaturesPref = createPreference('rec:expFeatures', {
  fallback: false,
  encode: (b) => (b ? '1' : '0'),
  decode: (s) => s === '1',
});
